(ns quuppa.qsm.qpes.qpe-view
  "Page for one QPE"
  (:require [quuppa.qsm.permissions :as permissions]
            [quuppa.qsm.projects.events :as pe]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [quuppa.components :as components]
            [quuppa.ui.breadcrumbs :as b]
            [quuppa.ui.layout :as layout]
            [quuppa.peweb.peinfo :as peinfo]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.api-docs.component :as api-docs]
            [quuppa.qsm.api-keys.view :as api-keys]
            [quuppa.qsm.configuration.view :as configuration]
            [quuppa.qsm.events :as e]
            [quuppa.qsm.features :as features]
            [quuppa.qsm.site.events]
            [quuppa.qsm.view :as qsm-view]))

(def qpe-details-tabs-data
  [{:id :conf
    :label "Configuration"
    :route :conf
    :data-test-id "configuration-qpe-tab"}
   {:id :api
    :label "API tokens"
    :route :api
    :data-test-id "api-tokens-qpe-tab"}
   {:id :qpe-api-docs
    :label "API docs"
    :route :qpe-api-docs
    :data-test-id "api-docs-qpe-tab"}])

(defn qpe-details []
  (let [{:keys [qpe-identity]} @(rf/subscribe [:nav/path-params])
        qpe-subscribe (fn [[event-id & args]] (rf/subscribe (into [event-id qpe-identity] args)))
        qpe-dispatch (fn [[event-id & args]] (rf/dispatch (into [event-id qpe-identity] args)))
        qpe @(q/subscribe e/authorized-qpes {} [:result qpe-identity])
        selected-tab (or @(rf/subscribe [:nav/match :data :qpe-info-tab])
                         @(rf/subscribe [:nav/route-name]))
        opts {:qpe-subscribe qpe-subscribe
              :qpe-dispatch qpe-dispatch
              :qpe-identity qpe-identity
              :selected-peinfo-tab selected-tab
              :select-peinfo-tab (fn [{:keys [route]}]
                                   (rfe/href route {:qpe-identity (:identity qpe)}))
              :select-log-tab (fn [{:keys [log-type]}]
                                (rfe/href :qpe-info-log-type {:qpe-identity (:identity qpe)
                                                              :log-type log-type}))
              :parameters @(rf/subscribe [:nav/match :parameters])
              :features (features/get-features)}
        loading @(qpe-subscribe [:qpe/data :loading])
        owner-or-admin? (permissions/has-manage-permission?)]
    [layout/section
     [qsm-view/navbar-content
      [b/breadcrumbs
       {:class "my-0 pl-2"}
       [b/breadcrumb-item [:a
                           {:href (rfe/href :qpes)}
                           "Engines"]]
       [b/breadcrumb-current (:name qpe)]]]

     [:div.d-flex.flex-column.flex-grow-1
      [:div.d-flex.flex-column.mx-0.p-4.pb-0
       [peinfo/peinfo-header opts qpe]

       [peinfo/peinfo-nav (assoc opts :extra-tabs qpe-details-tabs-data)]]

      [components/error-boundary
       (case selected-tab
         :api [:f> api-keys/api-keys-view opts]
         :qpe-api-docs [api-docs/lazy-api-docs opts]
         :conf [:f> configuration/configuration-view
                {:qpe qpe
                 :opts opts
                 :owner-or-admin? owner-or-admin?}]
         (cond
           (= "offline" (:status qpe))
           [:div.p-4 "The QPE is not connected"]

           (= "health_check_failed" (:status qpe))
           [:div.p-4 "The QPE is unresponsive"]

           (= "preconfigured" (:status qpe))
           [:div.p-4 "The QPE is not yet configured. Go to configuration tab to get the token for configuration."]

           ;; The loading map isn't present in app-db after page load.
           ;; We write the loading map only when an event is triggered, that leads to data load.
           (or (nil? loading)
               (:server-info loading)
               (:controller-state loading))
           [:div.p-4.d-flex.justify-content-center
            [:h5 "Loading QPE state..."]]

           :else
           [peinfo/peinfo-tab opts qpe]))]]]))


(def qpe-controller
  {:id :qsm-qpe
   :parameters {:path [:qpe-identity]}
   :start (fn [params]
            (q/execute e/authorized-qpes {})
            (q/execute pe/projects-query {})
            (rf/dispatch [:init/state-all {:identity (-> params :path :qpe-identity)}]))
   :subscriptions (fn [match]
                    (let [qpe-identity (-> match :parameters :path :qpe-identity)]
                      [[:qpe/update {}]
                       [:qpe/position-events {:qpe-identity qpe-identity}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:current-project/state]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:current-project/info]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:current-project/info-partial]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/controller-state]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/file-sync-running]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/running?]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/existing-projects]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/server-info]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/start-changing-project]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:qpe/end-changing-project]}]]))})

;; Locator are part of the project
(def locators-controller
  {:id :qpe-locators
   :parameters {:path [:qpe-identity]}
   :subscriptions nil})

(def tag-controller
  {:id :qpe-tags
   :parameters {:path [:qpe-identity]}
   :start (fn [params]
            (rf/dispatch [:init/req-tags {:identity (-> params :path :qpe-identity)}]))
   :subscriptions (fn [match]
                    (let [qpe-identity (-> match :parameters :path :qpe-identity)]
                      [[:qpe/event {:qpe-identity qpe-identity :event [:tag/removed]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:tag/added]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:tag/updated]}]
                       [:qpe/event {:qpe-identity qpe-identity :event [:tags/locations-changed]}]]))})
